import * as React from 'react';

export const COUPON_CODE_TYPE_REGISTRATION_FREE = 0;
export const COUPON_CODE_TYPE_ADD_ONS = 1;
export const COUPON_CODE_TYPE_BOTH = 2;
